import { FC, CSSProperties } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


type LiveAreaProps = {
  petName?: string;
  defaultCss?: CSSProperties;
}

export const LiveArea: FC<LiveAreaProps> = ({ petName, defaultCss = {} }) => {
  return (
    <Box
      sx={{
        borderBottomLeftRadius: defaultCss.borderRadius,
        borderBottomRightRadius: defaultCss.borderRadius,
        clipPath: 'path("M 0 0 Q 95 15 190 0 L 190 70 L 0 70 L 0 0")',
      }}
      position="absolute"
      bottom={0}
      width="100%"
      height="65px"
      borderBottom={defaultCss.border}
      bgcolor={defaultCss.borderColor}
      overflow="hidden"
    >
      {petName && (
        <Typography
          mx={2}
          mt={2}
          textAlign="center"
          textTransform="uppercase"
          overflow="hidden"
          whiteSpace="nowrap"
          color="white"
        >
          {petName}
        </Typography>
      )}
    </Box>
  );
};
